module.exports = "https://pearup-project-assets.s3.eu-central-1.amazonaws.com/scratch/assets/5c09c852b427c6ada0f0e60e03cfcd1c.png";